import React, { useEffect, useState } from "react";
import OverlappingShields from "./OverlappingShields";

const Preloader = () => {
  const [hidden, setHidden] = useState(false);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFading(true), 1100);
    const hideTimer = setTimeout(() => setHidden(true), 1600);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(hideTimer);
    };
  }, []);

  if (hidden) return null;

  return (
    <div
      className={`fixed inset-0 z-[100] bg-ink flex flex-col items-center justify-center transition-opacity duration-500 ${
        fading ? "opacity-0" : "opacity-100"
      }`}
      data-testid="intro-preloader"
    >
      <OverlappingShields
        size={320}
        opacity={0.18}
        duration={26}
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
      />
      <div className="relative flex flex-col items-center justify-center">
        <div className="relative h-px w-24 bg-gold origin-left" />
        <div className="relative overflow-hidden mt-6">
          <p className="font-display text-xl sm:text-3xl tracking-[0.18em] text-cream text-center">
            IRON GATE <span className="text-gold">CONSULTING</span>
          </p>
        </div>
        <p className="relative text-gold/80 text-[10px] sm:text-xs tracking-[0.34em] uppercase mt-5">
          U.S. Veteran Owned and Operated
        </p>
        <div className="relative h-px w-24 bg-gold origin-right mt-6" />
      </div>
    </div>
  );
};

export default Preloader;
